// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"65343867","309":"773c5f85","676":"331c70a8","876":"3c7ca7a1"}[chunkId] + ".chunk.js";
};